import { render } from "./LedgerEntriesIndex.vue?vue&type=template&id=3a8188ce"
import script from "./LedgerEntriesIndex.vue?vue&type=script&lang=js"
export * from "./LedgerEntriesIndex.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__